import { ComponentProps } from 'react';

import { BorderedText } from '@/ui/BorderedText';
import { cx } from '@/ui/cva';

type SectionHeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type SectionHeadingProps<T extends SectionHeadingLevel> =
    ComponentProps<T> & {
        as?: SectionHeadingLevel;
    };

export function SectionHeading<T extends SectionHeadingLevel = 'h2'>({
    as: Comp = 'h2',
    children,
    className,
    ...props
}: SectionHeadingProps<T>) {
    return (
        <Comp
            {...props}
            className={cx('text-4xl font-semibold md:text-5xl', className)}
        >
            <BorderedText>{children}</BorderedText>
        </Comp>
    );
}
